<template>
    <div class="mine-view">
        <div class="mine-view-body">
            <div class="user-infos-mask">
                <template v-if="userInfos">
                    <img src="@/assets/defaultUserAvatar.png">
                    <p class="user-name">{{ langTransfer(userInfos.NickName) }}</p>
                    <p class="user-phoneNum">{{ langTransfer(userInfos.LoginName) }}</p>
                </template>
                <div class="mine-navs">
                    <p v-for="(item,index) in mineNavs"
                       :key="index"
                       :class="{'actived-nav-item': activedNavIndex === index }"
                       class="mine-nav-item"
                       @click="mineNavItemClick(item,index)">
                        <span :style="{background: themeColor}" class="actived-warn-icon"/>
                        {{ langTransfer(item.text) }}
                    </p>
                </div>
            </div>
            <router-view/>
        </div>
    </div>
</template>

<script>

    export default {
        components: {
        },
        props: {
        },
        data () {
            return {
                overviewScroll: null,
                mineNavs: [
                    {
                        text: '我的收藏',
                        routeName: 'collection'
                    },
                    {
                        text: '我的书架',
                        routeName: 'bookCase'
                    },
                    {
                        text: '账号设置',
                        routeName: 'userSetting'
                    }
                ],
                activedNavIndex: 0
            }
        },
        computed: {
            userInfos () {
                return this.$store.state.userInfos
            },
            themeColor () {
                return this.$store.state.themeColor
            },
            routeName () {
                return this.$route.name
            }
        },
        watch: {
            routeName (newVal) {
                this.activedNavIndex = this.mineNavs.findIndex((e) => {
                    return e.routeName === newVal
                })
            }
        },
        mounted () {
            this.initActivedNavIndex()
        },
        methods: {
            initActivedNavIndex () {
                const { name } = this.$route
                this.activedNavIndex = this.mineNavs.findIndex((e) => {
                    return e.routeName === name
                })
            },
            mineNavItemClick (item, index) {
                if (index === this.activedNavIndex) {
                    return
                }
                this.activedNavIndex = index
                const { routeName } = item
                if (routeName) {
                    this.$router.push({
                        name: routeName
                    })
                }
            }
        },
        beforeRouteEnter (to, from, next) {
            next((vm) => {
                const { userInfos } = vm.$store.state
                if (!userInfos) {
                    vm.$router.push({
                        path: '/'
                    })
                }
            })
        }
    }
</script>

<style lang="scss" scoped>
    .mine-view {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    .mine-view-body {
        width: 1140px;
        height: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        padding-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        position: relative;
    }

    .user-infos-mask {
        width: 270px;
        height: 450px;
        background: #FAFAFA;
        margin-right: 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;

        img {
            width: 128px;
            height: 128px;
            border-radius: 50%;
            display: block;
            margin: 30px 0 20px;
        }

        .user-name {
            
            font-size: 18px;
            color: #1A1A1A;
            text-align: center;
            line-height: 18px;
        }

        .user-phoneNum {
            
            font-size: 14px;
            color: #8590A6;
            text-align: center;
            line-height: 14px;
            margin: 10px 0 30px;
        }

        .mine-navs {
            width: 100%;
            height: 200px;
            box-sizing: border-box;
            padding: 30px 0;
            background: #fff;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
        }

        .mine-nav-item {
            
            font-size: 16px;
            color: #1A1A1A;
            text-align: center;
            line-height: 40px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }

        .actived-warn-icon {
            display: block;
            width: 4px;
            height: 16px;
            margin-right: 16px;
            background: #0084FF;
            border-radius: 2px;
            opacity: 0;
            transition: all .2s;
        }

        .actived-nav-item {

            .actived-warn-icon {
                opacity: 1;
            }
        }
    }

    .site-footer {
        position: absolute;
        bottom: 0;
        z-index: 0;
    }
</style>
